import WaveformSine from "jsx:$assets/widgets/waveform_sine.svg"
import WaveformTriangle from "jsx:$assets/widgets/waveform_triangle.svg"
import WaveformSquare from "jsx:$assets/widgets/waveform_square.svg"
import WaveformSaw from "jsx:$assets/widgets/waveform_saw.svg"
import { ParameterSlider } from "./ParameterSlider";

export function WaveformSlider({instrument}) {
    const waveformIcons = {
        sine: WaveformSine,
        triangle: WaveformTriangle,
        square: WaveformSquare,
        sawtooth: WaveformSaw,
    }
    const handler = instrument.getParameterHandler("osc_waveform");
    return <div data-widget-id="oscWaveform" className="flex flex-col w-full" style={{ gap: 10 }}>
        <ParameterSlider orientation="horizontal" parameterHandler={handler} noLabel="true" noOutput="true" style={{width: "75%"}} className="self-center"/>
        <div className="flex justify-between" style={{height: 10, paddingInline: 10}}>
            {handler.description.options.map(option => {
                const Icon = waveformIcons[option];
                return <Icon key={option} />
            })}
        </div>
    </div>
}